<!-- button-paginator.component.html -->
<div class="flex flex-col items-start mt-6 space-y-3">
  <div class="flex border-gray-200">
    <button (click)="onPageChange(1)" data-testid="pager-first"
            [disabled]="page() === 1"
            class="flex items-center justify-center w-10 h-8 text-gray-600 hover:text-gray-800 border rounded-l-[6px]">
      <svg class="h-3 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <polyline points="17,5 11,12 17,19"></polyline>
        <polyline points="11,5 5,12 11,19"></polyline>
      </svg>
    </button>

    <button (click)="onPageChange(page() - 1)" data-testid="pager-prev"
            [disabled]="page() === 1"
            class="flex items-center justify-center w-8 h-8 text-gray-400 hover:text-gray-600 border">
      <svg class="h-4 w-4" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <polyline points="15 18 9 12 15 6"></polyline>
      </svg>
    </button>

    @for (p of getVisiblePages(); track p) {
    @if (p === -1) {
    <span class="px-3 h-8 text-gray-600 text-sm border">...</span>
    } @else {
                <button (click)="onPageChange(p)"
                [class]="page() === p ? activeButtonClass() : inactiveButtonClass()">      {{ p }}
    </button>
    }
    }

    <button (click)="onPageChange(page() + 1)" data-testid="pager-next"
            [disabled]="page() === totalPages()"
            class="flex items-center justify-center w-8 h-8 text-gray-600 hover:text-gray-800 border">
      <svg class="h-3 w-3" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <polyline points="9,18 15,12 9,6"></polyline>
      </svg>
    </button>

    <button (click)="onPageChange(totalPages())" data-testid="pager-last"
            [disabled]="page() === totalPages()"
            class="flex items-center justify-center w-10 h-8 text-gray-600 hover:text-gray-800 border rounded-r-[6px]">
      <svg class="h-3 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <polyline points="7,5 13,12 7,19"></polyline>
        <polyline points="13,5 19,12 13,19"></polyline>
      </svg>
    </button>
  </div>
</div>
